<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row">
                        <div class="col-lg-4 mb-5 mb-lg-0">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" tag-name="h3" :init="EditorConfig" />
                        </div>
                        <!-- End Col -->

                        <div class="col-lg-8">
                            <!-- Accordion -->
                            <div class="accordion accordion-flush" id="accordionFAQ">
                                <!-- Accordion Item -->
                                <div class="accordion-item" v-for="(faq, idx) in BlockProps.FAQs">
                                    <div class="accordion-header" id="headingOne">
                                        <a class="accordion-button" role="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + idx" aria-expanded="true" aria-controls="collapseOne">
                                            {{faq.question}}
                                        </a>
                                    </div>
                                    <div :id="'collapse' + idx" class="accordion-collapse collapse" :class="idx==0? 'show' : 'collapsed'" aria-labelledby="headingOne" data-bs-parent="#accordionFAQ">
                                        <div class="accordion-body" v-html="faq.answer">

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!-- End Accordion -->
                        </div>
                        <!-- End Col -->
                    </div>
                    <!-- End Row -->
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="">Configure FAQ</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>

                        <div class="h5">Categories To Show</div>
                        <div v-for="(item, index) in MasterTagList" :key="index">
                            <input type="checkbox" v-model="BlockProps.Tags" :value="item">
                            {{ item }}
                        </div>



                    </div>
                    <div class="modal-footer">
                        <button @click="GetFAQs" type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import axios from '/src/components/NovaAxios.js';
    import { toast } from 'vue3-toastify';
    

    
    export default {
        inheritAttrs: false,
        name: 'FAQ',
        mixins: [ContentBlockBase],
        props: ['faqtags'],
        components: {
        },
        computed:
        {
            MasterTagList: function () {
                var x = this.Store.MasterFaqTags;
                if (this.faqtags) {
                    return this.faqtags
                }

                if (this.Store && this.Store.MasterFaqTags)
                {
                    return this.Store.MasterFaqTags;
                }
            }
        },
        data() {
            return {  
            };
        },
        watch: {
            //'BlockProps.Tags': function (newVal, oldVal) {
            //    this.GetFAQs();
            //}
        },
        methods:
        {
            GetFAQs: function () {
                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;

                axios.postForm('/API/GetFAQs', {
                    tagFilter: that.BlockProps.Tags,
                }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    if (response.data.success) {
                        that.BlockProps.FAQs = (response.data.faqs || []).sort((a, b) => {
                            const aOrder = a.sortOrder ?? 0;
                            const bOrder = b.sortOrder ?? 0;
                            if (aOrder === bOrder) {
                                return 0;
                            }
                            return bOrder - aOrder;
                        });
                        if (that.iseditmode && (!response.data.faqs || !response.data.faqs.length)){
                            toast.warning("Be sure to add Frequently Asked Questions and answers (currently shown on this page) via the admin site at <a target='_blank' href='https://admin.notarylaunchpad.com/home/faq'>https://admin.notarylaunchpad.com</a>, or consider removing the FAQ page block."
                            , {'position': 'top-center'});
                        }
                    }
                    else {
                        toast.error("Failed loading FAQs! " + response.data.msg);
                    }

                }).catch(function (error) {
                    toast.error("There was an error. Please refresh the page and try again.");
                });
            },
         
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
        
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
           
        },
        beforeUnmount()
        {
           
        },
        mounted() {
            this.GetFAQs();
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

